import { ArrowBackTwoTone } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import customer from "../../images/customer.jpg";
import LoanImage from "../../images/LoanImage1.png";

import "./../Pagelayout/PageLayout.css";
import CustomerDetails from "./DetailPages/CustomerDetails";

import "./CovStyles.css";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { useRef } from "react";
import { useEffect } from "react";

const CovMainDashboard = () => {
  const filterScreen = useSelector((state) => state.cov.filterScreen);

  const [showCustomer, setShowCustomer] = useState(false);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
    },
  }));
  const navigate = useNavigate();
  const appNum = localStorage.getItem("appNum");
  const dispatch = useDispatch();
  //shortcut key
  const backRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "covMainDashboard",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "z") {
        backRef.current.click();
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          marginTop: "8px",
          marginBottom: "4px",
          display: "flex",
          gap: "8px",
          justifyContent: "space-between",
        }}
      >
        <Tooltip title="Back(Ctrl+z)">
          <IconButton
            aria-label="Back"
            color="primary"
            onClick={() => {
              navigate("/stlap/home/cov");
            }}
            ref={backRef}
          >
            <ArrowBackTwoTone fontSize="large" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box
        sx={{
          justifyContent: "left",
          marginTop: "8px",
          marginBottom: "4px",
          display: "flex",
          gap: "8px",
        }}
      >
        <h4>Selected Application Number is : {appNum}</h4>
      </Box>

      <div class="row">
        {/* <div>
          <Card
            sx={{ background: "#E0F2F7", borderRadius: "12px" }}
            onClick={() => {
              navigate("/stlap/home/los/CovLosDashboard");
            }}
            className="covListCards"
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: "18px",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <img src={customer} />
                  </Box>

                  <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                      Los Details
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </div> */}
        <div style={{ marginLeft: "2%" }}>
          <Card
            sx={{ background: "#E0F2F7", borderRadius: "12px" }}
            onClick={() => {
              navigate("/stlap/home/CovLoanDetailsDashboard");
            }}
            className="covListCards"
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: "18px",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <img src={LoanImage} />
                  </Box>

                  <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                      Loan Details
                    </Typography>
                    {/* <Box
                      sx={{
                        padding: "3px",
                        color: "white",
                        background: "#090979",
                        fontWeight: 600,
                        borderRadius: "8px",
                      }}
                    >
                      Disbursement Completed
                    </Box> */}
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </div>
      </div>

      <Dialog
        onClose={() => {
          setShowCustomer(false);
        }}
        open={showCustomer}
        maxWidth={"md"}
        sx={{ marginTop: "60px" }}
        fullScreen
      >
        <DialogContent>
          <h4>{"Customer Details"}</h4>
          <CustomerDetails setShowDetail={setShowCustomer} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CovMainDashboard;
